<script>
import SheetsRow from './SheetsRow'
import { actions } from '@utils'
import { byDesc } from '@utils/collections'

export default {
  components: {
    SheetsRow,
  },
  data() {
    return {
      isCreatingSpreadsheet: false,
    }
  },
  methods: {
    async createSheet() {
      const LIMIT = 100

      const { spreadsheetUrl } = await this.$wrap(
        () => {
          const laptopsEvaluationWithoutSelected = this.laptopEvaluations
            .filter(laptopEvaluation => !this.laptopIdsSelected.includes(laptopEvaluation.id))

          const laptopsEvaluationSelected = this.laptopEvaluations
            .filter(laptopEvaluation => this.laptopIdsSelected.includes(laptopEvaluation.id))
            .map(laptopEvaluation => ({
              ...laptopEvaluation,
              isSelected: true,
            }))

          const laptopsEvaluationWithoutSelectedLimited = [...laptopsEvaluationWithoutSelected]
            .sort(byDesc('valueScore'))
            .slice(0, LIMIT - this.laptopIdsSelected.length)

          return this
            .CREATE_ARTICLE_SHEET({
              topic: this.article.topic,
              articleId: this.article.id,
              laptopEvaluations: [
                ...laptopsEvaluationSelected,
                ...laptopsEvaluationWithoutSelectedLimited,
              ],
            })
        },
        'isCreatingSpreadsheet',
      )

      this.upArticle(['spreadsheetUrl'], spreadsheetUrl)
    },
    ...actions('CREATE_ARTICLE_SHEET'),
  },
  render: () => '',
}
</script>
